export const baseURL = "https://lmsplus.digitallandscape.com.pk:5034/"; // Demo/Client/Production
